import config from '@/config'
import Ajax from '@/libs/ajax'

const ajax = new Ajax(config.serverConfig.serviceURL);

// 入账流水报表
const blocBillingLog = ajax.post('/fin/bloc/report/blocBillingLog');

// 集团仪表盘
const blocDashboard = ajax.post('/fin/bloc/report/blocDashboard');

export default {
  blocBillingLog,
  blocDashboard
}